module.exports = __webpack_public_path__ + "static/img/tsLogo.202fcb30.png";